import type { Track } from '../../track/TrackLoader';
import type { TrackMeshes } from '../../track/TrackRenderer';
import type { TrackSelection } from '../../track/TrackRegistry';
import type { LandscapeVersion } from '../../render/Landscape';
import { buildCheckpoints, CheckpointTracker, type Checkpoint } from '../../track/Checkpoints';
import { isOnTrack, locateTrackPosition } from '../../track/TrackLoader';
import { trackSurfaceHeightAtPosition } from '../../track/TrackElevation';
import type { System } from '../ServiceLocator';

export class TrackSystem implements System {
  readonly name = 'TrackSystem';

  readonly trackUrl: string;
  readonly trackId: string;
  readonly landscapeVersion: LandscapeVersion;

  track!: Track;
  trackMeshes?: TrackMeshes;
  checkpoints?: Checkpoint[];
  cpTracker?: CheckpointTracker;

  constructor(selection: TrackSelection, landscapeVersion: LandscapeVersion) {
    this.trackUrl = selection.url;
    this.trackId = selection.id;
    this.landscapeVersion = landscapeVersion;
  }

  setTrack(track: Track): void {
    this.track = track;
  }

  setMeshes(meshes: TrackMeshes): void {
    this.trackMeshes = meshes;
  }

  buildCheckpointsFromTrack(): CheckpointTracker {
    this.checkpoints = buildCheckpoints(this.track);
    this.cpTracker = new CheckpointTracker(this.checkpoints);
    return this.cpTracker;
  }

  isOnTrack = (x: number, z: number): boolean => isOnTrack(this.track, x, z);
  locateTrackPosition = (x: number, z: number) => locateTrackPosition(this.track, x, z);
  trackSurfaceHeightAtPosition = (x: number, z: number): number => trackSurfaceHeightAtPosition(this.track, x, z);

  /** Fields this system contributes to the window.__twin debug surface. */
  debugEntries(): Record<string, unknown> {
    return {
      track: this.track,
      trackMeshes: this.trackMeshes,
      isOnTrack: this.isOnTrack,
      locateTrackPosition: this.locateTrackPosition,
      trackSurfaceHeightAtPosition: this.trackSurfaceHeightAtPosition,
    };
  }
}
